<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import moment from "moment";
import VueQRCodeComponent from 'vue-qrcode-component'
import formdate from "../formcomponet/formdate.vue";

export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "FirmaId","MuayeneKabulUpdate"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "99999",
        PageDataSize: "1",
      },
      Malzemeler: {},
      MalzemeSayisi: 0,
      Fiyatlar: [],
      FiyatSayisi: 0,
      FiyatlarArray: [],
      Muayenekabulkomisyonu: "",
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      Dosyaadi: "",
      Dosya: {},
      TableData: {},
      Firmalar: {},
      Malzeme: {},
      FaturaBilgileri:{},
      Alimturu: "",
      Firmaadi:"",
      TutanakSiraNo: "",
      tarih: null,
      GununTarihi: moment(String(new Date())).format("DD.MM.YYYY") ,
      IsHizmetAlimi: false
      
    };
  },
  components: {
    Loader,VueQRCodeComponent,
    formdate
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
    FirmaId() {
      this.Get();

    },
    MuayeneKabulUpdate(){
      this.Get();
    }
  },
  methods: {
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.Dosyaadi = res.Data.Dosyaadi;
        this.Dosya = res.Data;
        this.FirmaKase();
        this.ActionsGet({ Service: "OkeyValues/" + res.Data.Alimturu, Page: this.Page }).then((res) => {
          if (res) {
            this.Alimturu = res.Data.Value.toUpperCase();
            
          }
        });
        this.Muayenekabulkomisyonu = res.Data.Muayenekabulkomisyonu;
      });

      this.ActionsSingleGet({
        Service: "SatDosyaFirma",
        Id: this.FirmaId,
      }).then((res) => {
        this.ActionsFilterGet({
        Service: "OFirma",
        Page: this.Page,
        Filter: "&Id=" + res.Data.Firmaid
      }).then((res) => {   
        this.Firmaadi = res.Data[0].Firmaadi
      });
      });

      this.ActionsFilterGet({
        Service: "satdosyafatura",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId+
        "&Dosyafirmaid=" + this.FirmaId,
      }).then((res) => {   
      this.FaturaBilgileri = res.Data[0] || {};
      this.GetTutanakSiraNo();
      });

      let Filter = "&Dosyaid=" + this.satdosyaId + "&Durum=0&Asc=Sirano";
      if (this.FirmaId) Filter += "&Kazananfirmaid=" + this.FirmaId;
      this.ActionsFilterGet({
        Service: "satdosyamalzeme",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        /*for(var Data in this.TableData){
          this.ActionsFilterGet({
        Service: "satdosyafirmafiyat",
        Page: this.Page,
        Filter: "&Firmaturu=2&Dosyafirmaid=" + this.FirmaId + "&Dosyamalzemeid=" + this.TableData[Data].Id ,
      }).then((resp) => {
        console.log(resp.Data[0].Birimfiyat)
        this.TableData[Data].Aciklama = resp.Data[0].Birimfiyat

        
      });
        }*/
        this.$emit("TableUpdate", this.MuayeneKabulUpdate); 
 
        
      });
    },
    GetTutanakSiraNo() {
      this.TutanakSiraNo = "";
      if (!this.FaturaBilgileri || !this.FaturaBilgileri.Birimid || !this.FaturaBilgileri.Faturatarihi) return;

      const faturaYili = moment(this.FaturaBilgileri.Faturatarihi).year();
      this.ActionsFilterGet({
        Service: "satdosyafatura",
        Page: this.Page,
        Filter: "",
      }).then((res) => {
        const faturalar = (res.Data || [])
          .filter((fatura) =>
            fatura.Birimid == this.FaturaBilgileri.Birimid &&
            fatura.Faturatarihi &&
            moment(fatura.Faturatarihi).year() == faturaYili
          )
          .sort((a, b) => {
            const tarihFarki = moment(a.Faturatarihi).valueOf() - moment(b.Faturatarihi).valueOf();
            if (tarihFarki != 0) return tarihFarki;
            return String(a.Id || "").localeCompare(String(b.Id || ""));
          });

        const tutanakIndex = faturalar.findIndex((fatura) => fatura.Id == this.FaturaBilgileri.Id);
        this.TutanakSiraNo = faturaYili + "/" + (tutanakIndex >= 0 ? tutanakIndex + 1 : faturalar.length);
      });
    },
    FirmaKase(){
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      let Filter = "&Tip=1548&Kod=2";
      this.ActionsFilterGet({ Service: "OKeyValues", Page: Page, Filter: Filter }).then((res) => {
        if(res.Data[0].Id == this.Dosya.Alimturu){
          this.IsHizmetAlimi = true;

        }else{
          this.IsHizmetAlimi = false;
        }
      });
    },

    teklifkontrol() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "satdosyazarfacmakontrol",
        Page: Page,
        Filter: "&Dosyaid=" + this.satdosyaId,
      }).then((ressatdosyazarfacmakontrol) => {
        if (ressatdosyazarfacmakontrol) {
          this.gecersiz_teklifler = [];
          this.gecerli_teklifler = [];
          console.log("///////");
          console.log(ressatdosyazarfacmakontrol);
          for (var j = 0; j < ressatdosyazarfacmakontrol.Data.length; j++) {
            let istenenbelgeler = JSON.parse(
              ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler
            );

            // alert(Object.values(istenenbelgeler)[0])
            let belge_kontrol = 0;

            for (var i = 0; i < Object.values(istenenbelgeler).length; i++) {
              if (Object.values(istenenbelgeler)[i] > 1) {
                belge_kontrol = 1;
              }
            }

            let zarffirma = "";
            for (i = 0; i < this.TableData.length; i++) {
              if (
                this.TableData[i].Id ==
                ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid
              ) {
                zarffirma = this.TableData[i];
              }
            }
            if (belge_kontrol == 0) {
              this.gecerli_teklifler.push(zarffirma);
            } else {
              this.gecersiz_teklifler.push(zarffirma);
            }
          }

          this.gecerliteklifler();
        }
      });
    },
    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.PiyasaArastirmaTutanagi;
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },

    Export2Word(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    }
  },
};
</script>


<template>
  <Loader>
    <b-modal
      id="muayenekabulraporu"
      size="xl"
      scrollable
      :title="$t('muayenekabulraporu.Title')"
      title-class="font-18"
      hide-footer
      v-if="TableData.length != 0"
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <formdate :FormDataType='{
                        FieldName: "DüzenlenmeTarihi",
                        Field: "input",
                        FieldTitle: "Belge Düzenlenme Tarihi",
                        FieldType: "date",
                      }' :Value="tarih" v=null
                        @input="tarih = $event" v-model="tarih" />
                </div>
                <div class="col-sm-8">

                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="
                        ExcelExport(
                          'Muayene Kabul Raporu',
                          'Muayene Kabul Raporu'
                        )
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      {{ $t("muayenekabulraporu.Page.ExceleAktar") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="
                        Export2Word('exportContent', 'Muayene Kabul Raporu')
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>

                      {{ $t("muayenekabulraporu.Page.WordeAktar") }}
                    </button>
                  </div>
                </div>
              </div>

              <div id="exportContent">
                <div class="table-responsive" ref="PiyasaArastirmaTutanagi">
                  <table
                    class="table table-borderless mb-0"
                    style="width: 100%"
                  >
                    <thead>
                      <tr>
                        <th :colspan="2" class="text-sm-center">
                          {{ Alimturu }} MUAYENE VE KABUL TUTANAĞI
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="2" class="text-sm-center">
                          MUAYENE KABUL KOMİSYON TUTANAĞI 
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th :colspan="2" scope="row">
                          <div style="display: flex; justify-content: space-between; align-items: center; gap: 16px; white-space: nowrap;">
                            <span style="color: #000;">
                              Tutanak S&#305;ra No: {{ TutanakSiraNo }}
                            </span>
                            <span>
                              Düzenleme Tarihi: {{ tarih | formatDateTable }}
                            </span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="2" scope="row" style="text-align: left">
                          Firma Adı :  {{ Firmaadi }}
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" style="text-align: left">Birimi :  {{ FaturaBilgileri.Birimadi }}</th>
                      </tr>
                      <tr>
                        <th :colspan="2" scope="row" style="text-align: left">
                          Birim Kodu :  {{ FaturaBilgileri.Birimkodu }}
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" style="text-align: left">
                          Fatura Tarihi :  {{ FaturaBilgileri.Faturatarihi | formatDateTable }}
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" style="text-align: left">
                          Fatura No. :  {{ FaturaBilgileri.Faturanumarasi }}
                        </th>
                      </tr>
                      <tr>
                        <th scope="row" style="text-align: left">
                          Fatura Tutarı : {{ FaturaBilgileri.Kdvlifaturatutari }}
                        </th>
                      </tr> 
                      <tr>
                        <th scope="row" style="text-align: left">
                          Onayının Tarih ve No.Su :  {{ FaturaBilgileri.Onaytarihvenumarasi }}
                        </th> 
                      </tr>

                      <tr>
                        <td :colspan="2"></td>
                      </tr>
                      <tr>
                        <td :colspan="2">
                          <table
                            style="  border-collapse: collapse; width: 100%"
                            class="table table-bordered mb-0"
                          >
                            <tbody>
                              <tr >
                                <th style="text-align: center; border: 1px solid;">S.No.</th>
                                <th style="border: 1px solid;">HİZMETİN CİNSİ</th>
                                <th style="border: 1px solid;">MİKTARI</th>
                                <th style="border: 1px solid;">BİRİMİ</th>
                                <th style="border: 1px solid;">BİRİM FİYATI</th>
                                <th style="border: 1px solid;">TUTARI</th>
                              </tr>

                              <tr
                                v-for="(Malzeme, index) in TableData"
                                :key="index"
                              >
                                <td style="text-align: center; border: 1px solid;">
                                  {{ Malzeme.Sirano }}
                                </td>
                                <td  style="border: 1px solid;">{{ Malzeme.MalzemeAdi }}</td>
                                <td style="border: 1px solid;">{{ Malzeme.Adet }}</td>
                                <td style="border: 1px solid;">{{ Malzeme.Olcubirimiadi }}</td>
                                <td style="border: 1px solid;">{{ Malzeme.Kazananbirimfiyat }}</td>
                                <td style="border: 1px solid;">{{ Malzeme.Kazananbirimfiyat*Malzeme.Adet }} TL</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>


                      <tr>
                        <td :colspan="2" >
                          Yukarıda belirtilen iş kapsamında alımı yapılan mal/malzemelerin, komisyonumuzca yapılan incelemesinde kabul edilmesine engel teşkil edebilecek eksik, hata ve kusurun bulunmadığı tespit edilmiş olup bedelinin ödenmesinde sakınca bulunmamaktadır.  
                        </td>
                      </tr>
                      <tr>
                        <td :colspan="2"></td>
                      </tr>
                      <tr>
                        <th :colspan="2" class="text-sm-center">
                          MUAYENE VE KABUL KOMİSYON BAŞKANLIĞINA  
                        </th>
                      </tr>
                      <tr>
                        <td>Birimimiz satın alınan cins ve miktarı yukarıda belirtilen <b>{{ TableData.length }}</b>
                          kalem mal/malzemelerın  yapılan muayenesinde, belirtilen niteliklere haiz 
                          olduğu tespit edilmiş olup söz konusu malzemelerin kabulüne oy birliği ile 
                          karar verilmiş ve mal/malzemeler "<b>{{ TableData[0].Kazananfirmaadi }}</b
                          >" firmasından teslim alınmıştır.
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <table
                            class="table table-borderless mb-0"
                            style="width: 100%; border-collapse: collapse;"
                          >
                            <thead></thead>
                            <tbody>
                              <tr>
                                <td  style="border: 1px solid; text-align: center; font-weight: bold"
                                  :colspan="Muayenekabulkomisyonu.length*2"
                                >
                                  Görevliler
                                </td>
                                <td  style="border: 1px solid; text-align: center; font-weight: bold"
                                  colspan="2"
                             v-if="IsHizmetAlimi"   >
                                Yüklenici Firma
                                </td>

                              </tr>
                              <tr>
                                <td  style="border: 1px solid;"
                                  colspan="2"
                                  v-for="(
                                    Gorevliler, index
                                  ) in Muayenekabulkomisyonu"
                                  :key="index"
                                >
                                  {{ Gorevliler.AdSoyad }}
                                </td>
                                <td  style="border: 1px solid; text-align: center;"
                                  colspan="2"
                             v-if="IsHizmetAlimi"   >
                                {{ this.Firmaadi }}
                                </td>
                              </tr>
                              <tr>
                                <td  style="border: 1px solid;"
                                  colspan="2"
                                  v-for="(
                                    Gorevliler, index
                                  ) in Muayenekabulkomisyonu"
                                  :key="index"
                                >
                                  {{ Gorevliler.Unvan }}
                                </td>
                                <td  style="border: 1px solid;"
                                  colspan="2"
                              v-if="IsHizmetAlimi"  >
                                İmza/Kaşe:
                                </td>

                              </tr>
                              <tr>
                                <td  style="border: 1px solid;"
                                  colspan="2"
                                  v-for="(
                                    Gorevliler, index
                                  ) in Yaklasikmaliyetgorevliler"
                                  :key="index"
                                ></td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
        

                  </table>
                  <VueQRCodeComponent  style=" float: right; margin-top: 20px;"
                  
                size="100"
                :text='"İşin Adı: "+Dosyaadi+"  DÜZENLENME TARİHİ:"+GununTarihi+" Oluşturan Kullanıcı:"+UserNameSurName' /> 
              
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
